import moment from "moment"
import myComments from "../feed/myComments"

export const isNewPoll = (poll) => {
  const now = moment()
  const endsAt = moment(poll.endsAt)
  const expiresAt = endsAt.clone().add(3, "days")

  return now.isBefore(expiresAt) && myComments(poll).length === 0
}

export const isNewRecognition = (recognition) => {
  const now = moment()
  const createdAt = moment(recognition.createdAt || recognition.when)
  const expiresAt = createdAt.clone().add(3, "days")

  return now.isBefore(expiresAt) && myComments(recognition).length === 0
}
